window.onscroll = function () {
    stickMenu()
};

var navbar = document.getElementById("HeaderDesktop");
var sticky = navbar && navbar.offsetTop ? navbar.offsetTop : 0 ;

function stickMenu() {

    if (window.pageYOffset >= 0 && navbar) {
        navbar.classList.add("Header--sticky");
        $(navbar).next().addClass('Section--first')
    }
    if (window.pageYOffset === 0 && sticky === 0 && navbar) {
        navbar.classList.remove("Header--sticky");
        $(navbar).next().removeClass('Section--first')
    }
}
